import Vue from 'vue'
import Router from 'vue-router'

import NotFound from '@/views/NotFound.vue'

import { authenticationGuard, localeGuard } from './guards'

Vue.use(Router)

// Router view placeholder for empty routes
const routerView = { name: 'RenderView', render (c: any) { return c('router-view') } }

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: [
    {
      path: '/:locale([a-z]{2})?',
      component: routerView,
      children: [
        {
          path: 'forms',
          name: 'forms',
          props: true,
          beforeEnter: authenticationGuard,
          component: () => import(/* webpackChunkName: "forms" */ '@/views/Form.vue'),
        },
        {
          path: 'webforms/:companyCode/:formCode?',
          name: 'webforms',
          props: true,
          component: () => import(/* webpackChunkName: "web-forms" */ '@/views/WebForm.vue')
        },
        {
          path: 'login',
          name: 'login',
          component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
        },
        {
          // Redirect to forms for index.
          path: '',
          redirect: { name: 'forms' }
        },
        {
          // old tablet uri lookup redirect to forms
          path: '/preference/register/lookup',
          redirect: { name: 'forms' }
        },
        {
          // old webform uri redirect to webforms
          path: 'webform/:companyCode',
          redirect: to => ({ name: 'webforms', params: to.params })
        },
        {
          // 404 fallback
          path: '*',
          name: '404',
          component: NotFound
        }
      ]
    }
  ],
})


// Global guards
router.beforeEach(localeGuard)


export default router
